/* eslint-disable */
import {
  Box,
  Typography,
  Divider,
  Card,
} from '@mui/material';
import { useAppSelector } from '../../../store/hooks';


const KeyPerformanceCard = () => {
  const { skiptraceStats: { totalRevenue, totalBalance }, subscriptionTierMRR: { totalMRR } } = useAppSelector(state => state.whiltelabelSlice)
  const { account } = useAppSelector(state => state.userSlice.user)
  const metaData = account?.metadata ?? {
    isTotalRevenueVisible: true,
    isTotalMMRCombinedVisible: true,
    isTotalBalanceVisible: false,
    isCombinedRevenueVisible: false,
  };
  return (
    <Card
      sx={{
        p: 4, borderRadius: 3, width: '100%', height: '100%'
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: 0.1,
          mb: 1,
        }}
      >
        Key Performance
      </Typography>
      <Box display="flex" justifyContent='space-between'>
        {metaData.isCombinedRevenueVisible && (
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.1,
                mb: 1,
              }}
            >
              Total Revenue
            </Typography>
            <Typography sx={{ fontSize: 30, fontWeight: 700 }}>${Number((totalMRR + totalRevenue + totalBalance).toFixed(2))}</Typography>
          </Box>
        )}
        {metaData.isTotalMMRCombinedVisible && (
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.1,
                mb: 1,
              }}
            >
              Total (MRR Combined)
            </Typography>
            <Typography sx={{ fontSize: 30, fontWeight: 700 }}>${Number((totalMRR + totalRevenue).toFixed(2))}</Typography>
          </Box>
        )}
      </Box>

      <Divider sx={{ my: 1 }} />
      <Box display="flex" justifyContent='space-between'>
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: 0.1,
              mb: 1,
            }}
          >
            MRR
          </Typography>
          <Typography sx={{ fontSize: 20, fontWeight: 700 }}>${totalMRR}</Typography>
        </Box>
        {metaData.isTotalRevenueVisible && (
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.1,
                mb: 1,
              }}
            >
              Total Revenue Skiptrace(D)
            </Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>${totalRevenue}</Typography>
          </Box>
        )}
        {metaData.isTotalBalanceVisible && (
          <Box>
            <Typography
              sx={{
                fontSize: 11,
                textTransform: "uppercase",
                letterSpacing: 0.1,
                mb: 1,
              }}
            >
              Remaining Balance
            </Typography>
            <Typography sx={{ fontSize: 20, fontWeight: 700 }}>${totalBalance}</Typography>
          </Box>
        )}
      </Box>
    </Card>
  )
}

export default KeyPerformanceCard;